import api from '../../../services/api';
import EndPoints from '../../../services/endPoints';
import { types } from '../../types/types';
import { hideLoaderAction, showLoaderAction } from '../loaderAction';
import { showToast } from '../toastAction';

const getDepartmentEmployeeShifts = (departmentId, employeeId, setLoading, next) => async (dispatch) => {
    if (setLoading) {
        setLoading(true);
    }
    const res = await api('get', EndPoints.SETTINGS.MANAGE_EMPLOYEE.DEPARTMENT_EMPLOYEE_SHIFTS + departmentId + '/' + employeeId);
    if (res.success) {
        if (res.data) {
            next(res.data);
        }
    }
    if (setLoading) {
        setLoading(false);
    }
};

const addOrUpdateDepartmentShift = (id, data, setLoading, next) => async () => {
    setLoading(true);
    const res = await api('put', EndPoints.SETTINGS.MANAGE_EMPLOYEE.DEPARTMENT_EMPLOYEE_SHIFTS + id, data);
    if (res.success) {
        next(res.data);
    }
    setLoading(false);
};
const deleteDepartmentShift = (id, next) => async () => {
    const res = await api('delete', EndPoints.SETTINGS.MANAGE_EMPLOYEE.DEPARTMENT_EMPLOYEE_SHIFTS + id);
    if (res.success) {
        next(res.data);
    }
};

const copyDepartmentEmployeeShifts = (departmentId, data, setLoading, next) => async (dispatch) => {
    if (setLoading) {
        setLoading(true);
    }
    const res = await api('post', EndPoints.SETTINGS.MANAGE_EMPLOYEE.DEPARTMENT_EMPLOYEE_SHIFTS_COPY + departmentId, data);
    if (res.success) {
        if (res.data) {
            next(res.data);
        }
    }
    if (setLoading) {
        setLoading(false);
    }
};

export { getDepartmentEmployeeShifts, addOrUpdateDepartmentShift, deleteDepartmentShift, copyDepartmentEmployeeShifts };
